import instance from 'utils/axios/instance.axios';
import { BONUS_EXPENDITURE } from './_constant';

export const getAll = () => instance.get(BONUS_EXPENDITURE.GET_ALL);

export const getById = (id) => instance.get(BONUS_EXPENDITURE.GET_BY_ID(id));

export const create = (data = {}) => instance.post(BONUS_EXPENDITURE.CREATE, data);

export const update = ({ id, data = {} }) => instance.patch(BONUS_EXPENDITURE.UPDATE(id), data);

export const deleteById = (id) => instance.delete(BONUS_EXPENDITURE.DELETE(id));

export const restore = (id) => instance.patch(BONUS_EXPENDITURE.RESTORE(id));